export enum SentryBreadcrumbCategory {
  config = 'configuration',
  serviceWorker = 'service-worker',
  serviceWorkerUpdate = 'service-worker-update'
}
